import { illustrations } from '../../assets/illustrations';
import { Button } from '../../atoms/Button';

const DEFAULT_MESSAGE = 'Failed to load widget data. Please try again.';

export interface WidgetErrorStateProps {
  onRetry?: () => void;
  /**
   * Compact horizontal layout — illustration on the left, text + retry on the right.
   * Use inside metric-variant widgets where vertical space is tight.
   */
  compact?: boolean;
  message?: string;
}

export function WidgetErrorState({
  onRetry,
  compact = false,
  message = DEFAULT_MESSAGE,
}: WidgetErrorStateProps) {
  if (compact) {
    return (
      <div className="flex flex-wrap items-center justify-center gap-3">
        <img
          src={illustrations.databaseSleeping}
          alt=""
          aria-hidden="true"
          className="h-[72px] w-[84px] shrink-0"
        />
        <div className="flex min-w-[160px] flex-col items-center gap-2 text-center">
          <p className="text-[13px] leading-[1.3] text-grey-400">{message}</p>
          {onRetry && (
            <Button variant="outline" size="sm" onClick={onRetry}>
              Retry
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-6 text-center">
      <img
        src={illustrations.databaseSleeping}
        alt=""
        aria-hidden="true"
        className="h-[96px] w-[112px]"
      />
      <p className="text-[13px] leading-[1.3] text-grey-400">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}

WidgetErrorState.displayName = 'WidgetErrorState';
